import React from "react"
import { useDispatch, useSelector } from "react-redux"
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography
} from "@mui/material"
import { getReusableStepRebuildReportSelector } from "../../../../../reducers/Steps/steps"
import {
    closeReusableStepRebuildReport,
    rebuildRecipesAfterReusableStepUpdate
} from "../../../../../actions/Steps/reusableProductionSteps."
import { getRebuildReasonsLabel, getRecipeProductionStepsUrl } from "../../../../../utils/reusableStepRebuild"

const RecipeLink = ({ recipe }) => (
    <Link href={getRecipeProductionStepsUrl(recipe.objectId)} target="_blank" rel="noreferrer">
        {recipe.uniqueCode ? `[${recipe.uniqueCode}] ` : ""}{recipe.name || recipe.objectId}
    </Link>
)

/**
 * KFC-565: recipes not updated after a reusable step edition. Shown when the server left some
 * recipes untouched (Division des Sauces) or could not write them.
 */
const ReusableStepRebuildReportModal = () => {
    const dispatch = useDispatch()
    const rebuildReport = useSelector(getReusableStepRebuildReportSelector)

    if (!rebuildReport) return null

    const { reusableProductionStepId, recipesToUpdateManually = [], recipesFailed = [] } = rebuildReport

    const handleClose = () => dispatch(closeReusableStepRebuildReport())

    const handleRetry = () => {
        dispatch(closeReusableStepRebuildReport())
        dispatch(rebuildRecipesAfterReusableStepUpdate(reusableProductionStepId))
    }

    return (
        <Dialog open onClose={handleClose} maxWidth="sm" fullWidth aria-labelledby="reusable-step-rebuild-report-title">
            <DialogTitle id="reusable-step-rebuild-report-title">Recettes à mettre à jour</DialogTitle>
            <DialogContent>
                {recipesToUpdateManually.length > 0 && (
                    <>
                        <Typography variant="body2">
                            L'étape réutilisable est enregistrée, mais ces recettes n'ont pas été modifiées automatiquement.
                            Ouvrez chacune d'elles et mettez-la à jour vous-même.
                        </Typography>
                        <List dense>
                            {recipesToUpdateManually.map(recipe => (
                                <ListItem key={recipe.objectId} disableGutters>
                                    <ListItemText primary={<RecipeLink recipe={recipe} />} secondary={getRebuildReasonsLabel(recipe.reasons)} />
                                </ListItem>
                            ))}
                        </List>
                    </>
                )}
                {recipesFailed.length > 0 && (
                    <>
                        <Typography variant="body2">
                            La mise à jour de ces recettes a échoué. Vous pouvez la relancer.
                        </Typography>
                        <List dense>
                            {recipesFailed.map(recipe => (
                                <ListItem key={recipe.objectId} disableGutters>
                                    <ListItemText primary={<RecipeLink recipe={recipe} />} />
                                </ListItem>
                            ))}
                        </List>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                {recipesFailed.length > 0 && (
                    <Button onClick={handleRetry}>Relancer la mise à jour</Button>
                )}
                <Button onClick={handleClose} color="primary" variant="contained">Fermer</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ReusableStepRebuildReportModal
